import moment from "moment";
import { getWorkingDaysFromDB } from "../../../api/working-days-api";

// Returns an array of moment objects representing US federal holidays for the given year
export function getUSHolidays(year: number): moment.Moment[] {
    return [
        moment(`${year}-01-01`), // New Year's Day
        moment(`${year}-01-20`), // Martin Luther King Jr. Day (fixed for 2025, otherwise calculate 3rd Monday)
        moment(`${year}-02-17`), // Presidents Day (fixed for 2025, otherwise calculate 3rd Monday)
        moment(`${year}-05-26`), // Memorial Day (fixed for 2025, otherwise last Monday in May)
        moment(`${year}-06-19`), // Juneteenth
        moment(`${year}-07-04`), // Independence Day
        moment(`${year}-09-01`), // Labor Day (fixed for 2025, otherwise 1st Monday in September)
        moment(`${year}-10-13`), // Columbus Day (fixed for 2025, otherwise 2nd Monday in October)
        moment(`${year}-11-11`), // Veterans Day
        moment(`${year}-11-27`), // Thanksgiving Day (fixed for 2025, otherwise 4th Thursday in November)
        moment(`${year}-12-25`), // Christmas Day
    ];
}

// Utility function to calculate working days for each month of a given year, excluding weekends and US holidays
export function getWorkingDaysPerMonth(year: number): number[] {
    // console.log("Calculating working days for year:", year);
    const holidays = getUSHolidays(year).map((h) => h.format("YYYY-MM-DD")); // FIXME - No Holidays be default
    // console.log("Holidays for year", year, ":", holidays);
    const workingDays: number[] = [];
    for (let month = 0; month < 12; month++) {
        let count = 0;
        const daysInMonth = moment([year, month]).daysInMonth();
        for (let day = 1; day <= daysInMonth; day++) {
            const date = moment([year, month, day]);
            const dayOfWeek = date.day(); // 0 = Sunday, 6 = Saturday
            if (dayOfWeek !== 0 && dayOfWeek !== 6 && !holidays?.includes(date?.format("YYYY-MM-DD"))) {
                count++;
            }
        }
        workingDays.push(count);
    }
    // console.log("Working days for year", year, ":", workingDays);
    return workingDays;
}

export async function getWorkingDaysInMonth(year: number, month: number): Promise<number> {
    // Create a date object for the first day of the month
    // This function calculates the number of working days in a month
    // console.warn("getWorkingDaysInMonth :" + year + " " + month + " " + getWorkingDaysPerMonth(year)[month - 1]);
    return getWorkingDaysPerMonth(year)[month - 1] || 0; //FIXME
}

export async function getEffortsDetails(params: any) {
    console.warn("getEffortsDetails params:", params);

    // params.monthYear = params.year || moment().year(); // Format: "YYYY-MM";
    params.monthYear = moment(params?._d).format("YYYY-MM");

    // params.monthYear = '2023-10'; // FIXME - Hardcoded for testing

    // This function should fetch efforts details based on the provided parameters
    // Await the result and return it
    const data = await getWorkingDaysFromDB(params);
    // console.log("Working days data:", data);
    return data;
}
